import { AsyncPipe, JsonPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormMessageComponent } from 'src/app/ui-design-library/form-message/form-message.component';
import { ShowErrorComponent } from 'src/app/ui-design-library/forms/show-error/show-error.component';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { LoadComponent } from 'src/app/ui-design-library/load/load.component';

@Component({
  selector: 'fnsr-mail-send-result',
  standalone: true,
  imports: [LoadComponent, IconComponent, AsyncPipe, FormMessageComponent, ShowErrorComponent, ReactiveFormsModule, FormsModule, JsonPipe],
  templateUrl: './mail-send-result.component.html',
  styles: ``
})
export class MailSendResultComponent {
  @Input() mailSendResult: any;
}
